import React from "react";
import { Helmet } from 'react-helmet';
import NotificationsList from "./inc/NotificationsList"




function Notifications(){

return (


<div>

<Helmet>
        <title>سیستم یکپارچه مالی راینو - اخبار و اطلاعیه ها</title>
        <meta name="description" content="اخبار و اطلاعیه درباره خدمات و محصولات ما." />
        <meta name="keywords" content="اطلاع رسانی , اخبار , حسابداری ,مالیات ,حقوق دستمزد , راینو" />
</Helmet>


<section className="py-4 bg-light title">

   <div className="container">
     <div className="row">
        <div className="col-md-4 my-auto">
        <h3 className="float-end">اخبار/اطلاعیه ها</h3>
        </div>
      </div>
     </div>

</section>


<section className="section border-bottom">
  <div className="container">
  
  <NotificationsList typeNotify={1} />

  </div>

</section>


</div>


    )

}




export default Notifications;